/** Ver.iD trust-center pages linked from the hosted footer and the embedded details screen. */
export const TRUST_CENTER_LINKS = {
  privacyPolicy: 'https://ver.id/trust-center/privacy-policy',
  security: 'https://ver.id/trust-center/security',
} as const;
